import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import RatingStarsWidgetEditable from '../RatingStarsWidgetEditable';

const RatingPanel = ({
  text,
  onChangeRatingHandler,
  onBeforeChangeRatingHandler,
}) => {
  return (
    <div className="rating-firm-form">
      <div className="rating-firm-form__text">
        {`How would you rate ${text}? `}
      </div>
      <RatingStarsWidgetEditable
        value={0}
        size={20}
        onChangeHandler={onChangeRatingHandler}
        onBeforeChangeHandler={onBeforeChangeRatingHandler}
      />
    </div>
  );
};

RatingPanel.propTypes = {
  text: PropTypes.string.isRequired,
  onChangeRatingHandler: PropTypes.func.isRequired,
  onBeforeChangeRatingHandler: PropTypes.func.isRequired,
};

export default RatingPanel;
